"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _SupportParticipantSelectionStep = _interopRequireDefault(require("../../api/auth/SupportParticipantSelectionStep"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
class SupportParticipantSelectionStepModule extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onlyNumeric", e => {
      if (e.ctrlKey && e.key.toUpperCase() === 'V') {
        return;
      }
      const re = /Delete|Backspace|[0-9]+/g;
      if (!re.test(e.key)) {
        e.preventDefault();
      }
    });
    _defineProperty(this, "change", e => {
      const accountId = e.target.value;
      if (!accountId || accountId.length < 1) {
        this.setState({
          accountId,
          accountIdErrorMessage: 'Please enter the account id for the participant'
        });
      } else if (accountId && accountId.length > 9) {
        e.preventDefault();
      } else {
        this.setState({
          accountId,
          accountIdErrorMessage: null,
          errorMessage: null
        });
      }
    });
    _defineProperty(this, "submit", e => {
      e.preventDefault();
      const {
        accountId,
        disabled
      } = this.state;
      if (disabled) {
        return;
      }
      this.setState({
        errorMessage: '',
        isLoading: true
      });
      const step = new _SupportParticipantSelectionStep.default();
      step.accountId = accountId;
      // eslint-disable-next-line react/destructuring-assignment
      this.props.listener(this, step);
    });
    _defineProperty(this, "isAccountIdValid", () => {
      const {
        accountId
      } = this.state;
      return this.validateLength(accountId) && this.validateNumber(accountId);
    });
    this.state = {
      isLoading: false,
      accountId: undefined,
      accountIdErrorMessage: '',
      errorMessage: '',
      supportProfile: props?.stepResponse?.additionalData
    };
  }
  validateLength(value) {
    return value && value.length === 9;
  }
  validateNumber(value) {
    return /^\d+$/.test(value);
  }
  render() {
    const {
      isLoading,
      accountId,
      accountIdErrorMessage,
      errorMessage,
      supportProfile
    } = this.state;
    const disabled = !this.isAccountIdValid();
    console.log('disabled?', disabled);
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement(_core.OkModal, {
      header: "Unable to View Participant",
      message: errorMessage,
      display: errorMessage && errorMessage !== '',
      key: errorMessage
    }), /*#__PURE__*/_react.default.createElement("form", {
      id: "resetSecretForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4 pt-4"
    }, /*#__PURE__*/_react.default.createElement(_core.Title, {
      size: 1
    }, "Participant Selection"), /*#__PURE__*/_react.default.createElement(_core.Message, {
      type: "warning"
    }, "This functionality is for Authorized Personnel only. Use of this system is restricted to authorized users only. Unauthorized access or use is prohibited by law. Use will be monitored. Violators will be prosecuted."), /*#__PURE__*/_react.default.createElement(_core.Title, {
      size: 3
    }, "Welcome ", supportProfile.firstName, " ", supportProfile.lastName, "!"), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pt-3 pb-4"
    }, "Please provide the account id for the participant that you want to view."), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${accountIdErrorMessage && 'is-danger'}`,
      type: "text",
      placeholder: "Enter the participant's account id",
      id: "accountId",
      name: "accountId",
      size: "9",
      onChange: e => this.change(e),
      onBlur: e => this.change(e),
      onKeyDown: e => this.onlyNumeric(e),
      value: accountId,
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "person")))), decorateErrorMessage(accountIdErrorMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button pt-4"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Submit")))))));
  }
}
SupportParticipantSelectionStepModule.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(SupportParticipantSelectionStepModule);
//# sourceMappingURL=SupportParticipantSelectionStepModule.js.map